import type * as braze from '@braze/web-sdk';
import useUser from '@montugroup/circuit-shared/hooks/user/useUser';
import { useEffect, useState } from 'react';

import { changeUser, init, updateUserAttributes } from '@/services/braze.service';

let isInitialized = false;

/**
 * Inits Braze user tracking
 *
 * @returns brazeContentCards
 */
export type Card = braze.ClassicCard | braze.CaptionedImage | braze.Banner;

export function useBraze() {
  const [brazeContentCards, setBrazeContentCards] = useState<Card[]>([]);
  const { data: user } = useUser();

  useEffect(() => {
    if (!isInitialized) {
      init({ contentCardsSubscriber: ({ cards }) => setBrazeContentCards(cards as Card[]) });
      isInitialized = true;
    }
  }, [user]);

  useEffect(() => {
    if (user?.email) {
      changeUser(user.email);
    }
  }, [user?.email]);

  useEffect(() => {
    if (user) {
      updateUserAttributes({ user });
    }
  }, [user]);

  return { brazeContentCards };
}
